import { memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { isString } from 'lodash';
import PropTypes from 'prop-types';
// Import UI Components
import { Copy, Icon, Tooltip } from '@geneui/components';
// Import Constants
import { l } from 'constants/common';

const PartnerRow = ({ data }) => {
    const { t } = useTranslation();
    const copyableContentRef = useRef<HTMLParagraphElement>(null);
    const statusTooltipText = data.IsCrmActivated ? l.PartnerActiveTooltipText : l.PartnerNotActiveTooltipText;

    return (
        <div className="partner-row-elements-container">
            <div className="partner-row-elements-left">
                <Tooltip key={data.label} title={isString(data.label) ? data.label : ''}>
                    <span className={`crm-option-column-${data.value} ellipsis-text`}>{data.label}</span>
                </Tooltip>
            </div>

            <div className="partner-row-elements-right">
                <Copy
                    key={data.displayId}
                    size="small"
                    copiedTooltipText={t(l.IdCopied)}
                    contentRef={copyableContentRef}
                    showOnHover={true}
                />

                <p ref={copyableContentRef}>{data.displayId}</p>

                <Tooltip text={t(statusTooltipText)}>
                    <Icon
                        type="bc-icon-status-circle"
                        className={`${data.IsCrmActivated ? 'partner-active' : 'partner-not-active'}`}
                    />
                </Tooltip>
            </div>
        </div>
    );
};

PartnerRow.propTypes = {
    data: PropTypes.object,
    id: PropTypes.number,
};

export default memo(PartnerRow);
